export default {
  api: "https://ipci-reward.robonomics.network"
  // api: "http://localhost:3000"
};
